import { createPagination } from '~/shared/lib/pagination';

export const paginationModel = createPagination();
